import styled from 'styled-components';

import { breakpoints } from '~/styles/tools/breakpoints';

export const Container = styled.section`
  max-width: 136.3rem;
  max-height: 70.2rem;
  padding: 2.4rem;
  overflow-y: auto;

  /* &::-webkit-scrollbar {
    display: none;
  } */

  background: #fff;
  border-radius: 0.6rem;

  @media (max-width: ${breakpoints.medium}) {
    margin: 1.6rem auto;
    width: 90%;
  }
`;

export const Title = styled.h2`
  font-size: 2.8rem;
  color: #0f0f0f;
  letter-spacing: 0.168rem;
  text-transform: uppercase;

  @media (max-width: ${breakpoints.medium}) {
    text-align: center;
  }
`;

export const Header = styled.section`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.4rem;

  @media (max-width: ${breakpoints.medium}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 1.6rem;
  }
`;

export const Footer = styled.section`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 2.4rem;
`;
